
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owners/compliance-letter",
      function () {
        return require("private-next-pages/owners/compliance-letter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/owners/compliance-letter"])
      });
    }
  